<div class="project-card-container">
  <div class="project-status" [style.height]="getHeight()" [title]="getStatusTooltip()" [style.background-color]="projectData?.IsOnHold ? getStatusColor(5) : projectData?.HasShipped ? shippedColor : getStatusColor(projectData?.OverallStatusId)">
    <div *ngFor="let icon of icons" class="material-symbols-outlined-no-fill project-card-icon" [title]="icon.key">{{icon.value}}</div>
  </div>
  <div class="project-card" [style.height]="getHeight()" (click)="onCardClick()">
    <div class="project-card-header-line">
      <span class="project-card-number">{{projectData?.ProjectNumber}}</span>
      <span
        class="material-symbols-outlined-no-fill project-card-hot-icon"
        [class.project-card-hot-icon-active]="projectData?.IsHot"
        [class.project-card-hot-icon-busy]="isTogglingHot"
        title="Toggle Hot"
        (click)="toggleProjectHot($event)">local_fire_department</span>
      <span class="project-card-name">{{projectData?.ItemDescription}}</span>
      <div class="project-card-type-container">
        <ng-container *ngIf="projectData?.ProductTemplateId; else noTemplate">
          <a class="project-card-type project-card-template-link" (click)="openTemplateModal($event)">{{projectData?.TemplateName}}</a>
          <span class="material-symbols-outlined-no-fill project-card-template-action" title="Change Product Template" (click)="openTemplateModal($event)">autorenew</span>
        </ng-container>
        <ng-template #noTemplate>
          <a class="project-card-type project-card-no-template project-card-template-link" (click)="openTemplateModal($event)">(No Template)</a>
          <span class="material-symbols-outlined-no-fill project-card-template-action" title="Add Product Template" (click)="openTemplateModal($event)">add_circle</span>
        </ng-template>
        <span
          class="project-card-type"
          [title]="'AX: ' + projectData?.ProductCode + ' - ' + getProductCodeDescription(projectData?.ProductCode) + (projectData?.RtSelectProductCode ? ('\n' + 'RTSelect: ' + projectData?.RtSelectProductCode + ' - ' + getProductCodeDescription(projectData?.RtSelectProductCode)) : '')"
        >{{projectData?.RtSelectProductCode || projectData?.ProductCode}}</span>
      </div>
      <div class="project-card-icons-container">
        <div *ngIf="showViewIcons" class="material-symbols-outlined-no-fill project-card-view-icon" [class.project-card-view-icon-disabled]="!projectData.HasOrderDetails" title="Order Details" (click)="toggleDetailsView(ProjectCardView.OrderDetails, $event)">order_approve</div>
        <div *ngIf="showViewIcons" class="material-symbols-outlined-no-fill project-card-view-icon" [class.project-card-view-icon-muted]="!projectData.EngineeringCalculationCount" title="Engineering Calculations" (click)="toggleDetailsView(ProjectCardView.EngineeringCalculations, $event)">calculate</div>
        <div *ngIf="showViewIcons" class="material-symbols-outlined-no-fill project-card-view-icon" [class.project-card-view-icon-disabled]="true" title="Engineering Details" (click)="toggleDetailsView(ProjectCardView.EngineeringDetails, $event)">design_services</div>
        <div *ngIf="showViewIcons" class="material-symbols-outlined-no-fill project-card-view-icon" [class.project-card-view-icon-disabled]="!projectData?.ProductTemplateId" title="Schedule" (click)="toggleDetailsView(ProjectCardView.Schedule, $event)">calendar_today</div>
        <div *ngIf="showViewIcons" class="material-symbols-outlined-no-fill project-card-view-icon" [class.project-card-view-icon-disabled]="!projectData.DocumentCount" title="Documents" (click)="toggleDetailsView(ProjectCardView.Documents, $event)">docs</div>
        <span class="note-count-bubble"
          [class.project-card-view-icon-muted]="!projectData?.NoteCount"
          >{{projectData?.NoteCount}}</span>
        <div
          class="material-symbols-outlined-no-fill project-card-view-icon"
          [class.project-card-view-icon-muted]="!projectData?.NoteCount"
          (click)="onNotesClick($event)">chat</div>
      </div>
    </div>
    <div class="project-card-detail-line">
      <span class="project-card-label">End User:</span> {{projectData?.EndUser}}
      <span class="project-card-separator">|</span>
      <span class="project-card-label">Customer:</span> {{projectData?.Customer}}
      <span class="project-card-separator">|</span>
      <span class="project-card-label">PO Number:</span> {{projectData?.CustomerPo}}
    </div>
    <div class="project-card-detail-line">
      <span class="project-card-label">PO Date:</span> {{ projectData?.PoDate }}
      <span class="project-card-separator">|</span>
      <span class="project-card-label">Approval Drawing Date:</span> {{ projectData?.ApprovalDrawingDate }}
      <span class="project-card-separator">|</span>
      <span class="project-card-label">Requested Ship Date:</span> {{ projectData?.RequestedShipDate }}
      <span class="project-card-separator">|</span>
      <span class="project-card-label">Acknowledged Ship Date:</span> {{ projectData?.AcknowledgedShipDate }}
      <span class="project-card-separator">|</span>
      <span class="project-card-label">Current Ship Date:</span> {{ projectData?.CurrentShipDate }}
    </div>
    <div class="project-card-detail-line">
      <span class="project-card-label" *ngIf="projectData?.SalesRep">Sales Rep:</span> {{formatSalesRepName(projectData?.SalesRep)}}
      <span class="project-card-separator" *ngIf="projectData?.SalesRep && projectData?.SalesManager">|</span>
      <span class="project-card-label" *ngIf="projectData?.SalesManager">Sales Mgr:</span> {{projectData?.SalesManager}}
      <span class="project-card-separator" *ngIf="projectData?.SalesManager && projectData?.TechnicalEngineer">|</span>
      <span class="project-card-label" *ngIf="projectData?.TechnicalEngineer">Project Mgr:</span>{{projectData?.TechnicalEngineer}} <!-- Labels reversed from AX -->
      <span class="project-card-separator" *ngIf="projectData?.ProjectManager">|</span>
      <span class="project-card-label" *ngIf="projectData?.ProjectManager">Project Eng:</span>{{projectData?.ProjectManager}} <!-- Labels reversed from AX -->
      <span class="project-card-separator" *ngIf="projectData?.ProjectManager2">|</span>
      <span class="project-card-label" *ngIf="projectData?.ProjectManager2">Project Eng (Alt):</span>{{projectData?.ProjectManager2}} <!-- Labels reversed from AX -->
      <span class="project-card-separator" *ngIf="projectData?.Planner">|</span>
      <span class="project-card-label" *ngIf="projectData?.Planner">Planner:</span> {{projectData?.Planner}}
      <span class="project-card-separator">|</span>
      <a class="edit-names-link" (click)="editNames($event)">Edit Names</a>
    </div>
    <div class="project-card-detail-line">
      <span class="project-card-label" *ngIf="projectData?.MechanicalEngineer">Mech Engineer:</span> {{projectData?.MechanicalEngineer}}
      <span class="project-card-separator" *ngIf="projectData?.MechanicalEngineer && projectData?.MechanicalDrafter">|</span>
      <span class="project-card-label" *ngIf="projectData?.MechanicalDrafter">Mech Drafter:</span> {{projectData?.MechanicalDrafter}}
      <span class="project-card-separator" *ngIf="projectData?.ElectricalEngineer">|</span>
      <span class="project-card-label" *ngIf="projectData?.ElectricalEngineer">Elec Engineer:</span> {{projectData?.ElectricalEngineer}}
      <span class="project-card-separator" *ngIf="projectData?.ElectricalDrafter">|</span>
      <span class="project-card-label" *ngIf="projectData?.ElectricalDrafter">Elec Drafter:</span> {{projectData?.ElectricalDrafter}}
      <span class="project-card-separator" *ngIf="customNames && customNames.length > 0">|</span>
      <span *ngFor="let customName of customNames; let i = index">
        <span *ngIf="customName.Name">
          <span class="project-card-separator" *ngIf="i > 0">|</span>
          <span class="project-card-label">{{customName.Role}}:</span> {{customName.Name}}
        </span>
      </span>  
    </div>
    <div class="project-card-status-line">
      <span class="project-card-status-label">Sales:</span>
      <span class="project-card-status-block" [style.background-color]="getStatusColor(projectData?.SalesStatusId)"></span>
      <span class="project-card-status-label">Engineering:</span>
      <span class="project-card-status-block" [style.background-color]="getStatusColor(projectData?.EngineeringStatusId)"></span>
      <span class="project-card-status-label">Production:</span>
      <span class="project-card-status-block" [style.background-color]="getStatusColor(projectData?.ProductionStatusId)"></span>
      <span class="project-card-status-label">Pct Complete:</span>
      <span>{{ formatPercentComplete(projectData?.PercentComplete) }}</span>
      <ng-container *ngIf="formatCompletedEstimatedHours(projectData?.CompletedHours, projectData?.EstimatedHours) as completedEstimatedHours">
        <span>{{ completedEstimatedHours }}</span>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="notesModalVisible" class="modal-background">
  <div class="modal-dialog">
    <h2>Notes</h2>
    <div class="modal-content">

      <div class="notes-table-container modal-table-container">
        <table class="notes-table modal-table">
          <thead>
            <tr>
              <th class="modal-header-cell modal-col-date">Date</th>
              <th class="modal-header-cell modal-col-user">User</th>
              <th class="modal-header-cell modal-col-activity">Activity</th>
              <th class="modal-header-cell">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let n of notes">
              <td class="modal-cell modal-col-date">{{ toBrowserDate(n?.Created) | date:'short' }}</td>
              <td class="modal-cell modal-col-user">{{ n?.UserName }}</td>
              <td class="modal-cell modal-col-activity">{{ n?.ActivityName }}</td>
              <td class="modal-cell modal-cell-pre-wrap">{{ n?.Text }}</td>
            </tr>
            <tr *ngIf="!notes || notes.length === 0">
              <td colspan="4" class="modal-empty-state">No notes available.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="notes-add-container">
        <textarea
          class="notes-add-input"
          rows="3"
          placeholder="Add a note"
          [(ngModel)]="newProjectNote"
        ></textarea>
        <div class="notes-add-actions">
          <button
            class="geaui-button-primary"
            [disabled]="isAddingProjectNote || !newProjectNote.trim()"
            (click)="addProjectNote()">Add Note</button>
        </div>
      </div>

      <div class="modal-actions-right">
        <button class="geaui-button-secondary" (click)="closeNotesModal()">Close</button>
      </div>

    </div>
  </div>
</div>

<div *ngIf="editNamesModalVisible" class="modal-background">
  <div class="modal-dialog modal-dialog-edit-names">
    <div class="edit-names-modal-header">
      <h2 class="modal-title">Edit Names</h2>
      <button class="geaui-button-primary add-custom-name-button" (click)="addCustomName()">Add Name</button>
    </div>
    <div class="modal-content">

      <div class="names-table-container modal-table-container">
        <table class="names-table modal-table">
          <thead>
            <tr>
              <th class="modal-header-cell modal-col-role">Role</th>
              <th class="modal-header-cell">Name</th>
              <th class="modal-header-cell modal-col-actions modal-text-center"></th>
            </tr>
          </thead>
          <tbody>
            <!-- Standard Names (Role Read-only) -->
            <tr *ngFor="let name of standardNames" [hidden]="name.Property === 'SalesRep'">
              <td class="modal-cell modal-col-role modal-font-bold">{{ name.Role }}</td>
              <td class="modal-cell">
                <multi-select-dropdown
                  [width]="'325px'"
                  [type]="name.Property"
                  [getOptions]="getOptions"
                  [value]="name.Name"
                  (valueChanged)="name.Name = $event"
                  [allowMultiSelect]="false"
                  [getOptionsType]="name.Property == 'ProjectManager2' ? 'ProjectManager' : undefined"
                ></multi-select-dropdown>
              </td>
              <td class="modal-cell modal-text-center modal-text-muted"></td>
            </tr>
            <!-- Custom Names (Role Editable) -->
            <tr *ngFor="let name of customNames; let i = index">
              <td class="modal-cell modal-col-role">
                <input type="text" #customNameRoleInput [(ngModel)]="name.Role" class="name-input name-role-input" />
              </td>
              <td class="modal-cell">
                <input type="text" [(ngModel)]="name.Name" class="name-input" />
              </td>
              <td class="modal-cell modal-text-center">
                <geaui-icon-v3
                  file="16px_remove"
                  (click)="deleteCustomName(name.Role)"
                  pTooltip="Delete Custom Name"
                  [clickable]="true"
                ></geaui-icon-v3>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-actions-split">
        <button class="geaui-button-secondary" (click)="openDuplicateNamesModal()">Save and Duplicate Names</button>
        <span>
          <button class="geaui-button-secondary modal-cancel-button" (click)="closeEditNamesModal()">Cancel</button>
          <button class="geaui-button-primary" (click)="saveEditedNames()">Save</button>
        </span>
      </div>

    </div>
  </div>
</div>

<div *ngIf="duplicateNamesModalVisible" class="modal-background">
  <div class="modal-dialog modal-dialog-small">
    <h2>Duplicate Names</h2>
    <div class="modal-content">

      <project-multi-selector
        [SelectedProjectId]="projectData?.Id"
        (SelectedProjectIds)="duplicateNamesSelectedProjectIds = $event">
      </project-multi-selector>

      <div class="modal-actions-right">
        <button class="geaui-button-secondary modal-cancel-button" (click)="closeDuplicateNamesModal()">Cancel</button>
        <button
          class="geaui-button-primary"
          [disabled]="isDuplicatingNames || duplicateNamesSelectedProjectIds.length === 0"
          (click)="saveAndDuplicateNames()">OK</button>
      </div>

    </div>
  </div>
</div>

<div *ngIf="isDuplicatingNames" class="modal-background">
  <div class="modal-dialog modal-dialog-small processing-dialog">
    <p>Processing...</p>
  </div>
</div>

<div *ngIf="templateModalVisible" class="modal-background">
  <div class="modal-dialog modal-dialog-small">
    <h2>{{ projectData?.ProductTemplateId ? 'Change Product Template' : 'Add Product Template' }}</h2>
    <div class="modal-content">

      <p class="template-modal-info-line"><span class="project-card-label">Project Number:</span> {{ projectData?.ProjectNumber }}</p>
      <p class="template-modal-info-line"><span class="project-card-label">Description:</span> {{ projectData?.ItemDescription }}</p>
      <p class="template-modal-info-line"><span class="project-card-label">AX Product Code (Sort 5):</span> {{ projectData?.ProductCode }} ({{ getProductCodeDescription(projectData?.ProductCode) }})</p>
      <p class="template-modal-info-line"><span class="project-card-label">RTSelect Product Code:</span> {{ projectData?.RtSelectProductCode }} ({{ getProductCodeDescription(projectData?.RtSelectProductCode) }})</p>
      <p class="template-modal-info-line" *ngIf="projectData?.ProductTemplateId"><span class="project-card-label">Existing Template:</span> {{ projectData?.TemplateName }}</p>

      <select class="template-select" [(ngModel)]="selectedTemplateName">
        <option value="" disabled>(Select Template)</option>
        <option *ngFor="let option of templateOptions" [value]="option">{{ option }}</option>
      </select>

      <div class="modal-actions-right">
        <button class="geaui-button-secondary modal-cancel-button" (click)="closeTemplateModal()">Cancel</button>
        <button
          class="geaui-button-primary"
          [disabled]="isSavingTemplate || !selectedTemplateName"
          (click)="saveTemplate()">OK</button>
      </div>

    </div>
  </div>
</div>

<div *ngIf="isSavingTemplate" class="modal-background">
  <div class="modal-dialog modal-dialog-small processing-dialog">
    <p>Building template...</p>
  </div>
</div>

